import { render, staticRenderFns } from "./ShippingType.vue?vue&type=template&id=1acd0d5d&"
import script from "./ShippingType.vue?vue&type=script&lang=js&"
export * from "./ShippingType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports